<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <i class="fa fa-edit"></i> {{ $t('str.manage-forum-category') }}
            <div class="card-header-actions">
              <router-link to="/office/forum/category" class="card-header-action btn-setting">
                <buttons button-type="back" />
              </router-link>
            </div>
          </div>
          <b-form @submit.prevent="saveData">
            <b-row>
              <b-col sm="12">
                <table class="table">
                  <tbody>
                    <template v-if="id == 0">
                      <tr>
                        <th scope="row">{{$t('str.country')}}</th>
                        <td>
                          <b-input-group>
                            <b-form-select name="country" v-model="addData.country" @change="changeDirection">
                              <option :value="null">-</option>
                              <option v-for="(c, i) in countrySelect" :value="c.value" :key="i">{{c.text}}</option>
                            </b-form-select>
                          </b-input-group>
                          <span class="invalid-feedback">{{ errors.first('country') }}</span>
                        </td>
                      </tr>
                    </template>
                    <tr>
                      <th scope="row">{{$t('str.name')}}</th>
                      <td>
                        <b-form-input type="text" name="name"
                          :class="{ 'form-control': true, 'is-invalid': errors.has('name') }" id="name"
                          v-validate="{ required: true }" v-model="addData.name" :dir="ltr"/>
                        <span class="invalid-feedback">{{ errors.first('name') }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <buttons button-type="submit" />
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'

import Buttons from '@/views/component/Buttons'

export default {
  components: {
    'buttons': Buttons
  },
  data() {
    return {
      id: this.$route.params.id,
      countrySelect: [],
      addData: {
        name: '',
        country: ''
      },
      ltr: 'ltr',
      countryData: [],
    }
  },
  methods: {
    async getCountrySelect() {
      this.$auth.checkSession()
      try {
        let url = `${this.$helper.envi.VUE_APP_API_URL}/Country`
        if (this.$auth.session.get('role') == 'officer') {
          url = `${url}/ByUserOfficeSelect`
        }

        let getData = await axios.get(url, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data
        this.countryData = cData

        for (let i = 0; i < cData.length; i++) {
          this.countrySelect.push({ 'value': cData[i].id, 'text': cData[i].name })
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async getData() {
      this.$auth.checkSession()
      let dataId = this.id

      if (dataId > 0) {
        try {
          let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Forum/Category/${dataId}`, {
            headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
          })

          this.addData.name = getData.data.data.name
          this.addData.country = getData.data.data.country_id
          
          for (let i = 0; i < this.countryData.length; i++) {
            if (this.countryData[i].id == this.addData.country) {
              this.ltr = (this.countryData[i].is_right_to_left ? 'rtl' : 'ltr')
              break
            }
          }
        } catch (e) {
          console.log('err', e.response)
          if (e.response) {
            this.$router.push('/pages/404')
          }
        }
      }
    },
    async saveData() {
      this.$auth.checkSession()
      if (this.$validator.validateAll()) {
        let method = 'post'
        let url = `${this.$helper.envi.VUE_APP_API_URL}/Forum/Category`

        if (this.id > 0) {
          method = 'patch'
          url = `${url}/${this.id}`
        }

        try {
          var result = await axios[method](url, this.addData, {
            headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
          })

          this.$toast.success(result.data.meta.message, '', {
            position: 'topCenter'
          })

          if (this.id == 0)
            this.$router.push('/office/forum/category')
        } catch (e) {
          if (Array.isArray(e.response.data.meta.error)) {
            e.response.data.meta.error.forEach((err) => {
              this.$toast.error(err.msg, e.response.data.meta.message, {
                position: 'topCenter'
              })
            })
          } else if (typeof e.response.data.meta.error === 'string') {
            this.$toast.error(e.response.data.meta.message, e.response.data.meta.error, {
              position: 'topCenter'
            })
          }
        }
      }
    },

    async changeDirection(val) {
      for (let i = 0; i < this.countryData.length; i++) {
        if (this.countryData[i].id == val) {
          this.ltr = (this.countryData[i].is_right_to_left ? 'rtl' : 'ltr')
          break
        }
      }
    },
  },
  created() {
    this.getCountrySelect()
    this.getData()
  },
}
</script>